import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy loading de páginas
const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const CambioContrasenaPage = lazy(() => import('../pages/cambio-contrasena/page'));
const SetupSuperAdminPage = lazy(() => import('../pages/setup-superadmin/page'));
const RecoverAccessPage = lazy(() => import('../pages/recover-access/page'));

// Admin pages
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminUsuarios = lazy(() => import('../pages/admin/usuarios/page'));
const AdminEstudiantes = lazy(() => import('../pages/admin/estudiantes/page'));
const AdminMaterias = lazy(() => import('../pages/admin/materias/page'));
const AdminGrados = lazy(() => import('../pages/admin/grados/page'));
const AdminGrupos = lazy(() => import('../pages/admin/grupos/page'));
const AdminPeriodos = lazy(() => import('../pages/admin/periodos/page'));
const AdminAsignaciones = lazy(() => import('../pages/admin/asignaciones/page'));
const AdminBoletines = lazy(() => import('../pages/admin/boletines/page'));
const AdminCargaMasiva = lazy(() => import('../pages/admin/carga-masiva/page'));
const AdminConfiguracionCalificaciones = lazy(() => import('../pages/admin/configuracion-calificaciones/page'));
const AdminAñosAcademicos = lazy(() => import('../pages/admin/anos-academicos/page'));
const AdminCarteleraPage = lazy(() => import('../pages/admin/cartelera/page'));
const AdminInformacionAñosCerrados = lazy(() => import('../pages/admin/informacion-anos-cerrados/page'));
const AdminCopiasSeguridad = lazy(() => import('../pages/admin/copias-seguridad/page'));

// SuperAdmin pages
const SuperAdminDashboard = lazy(() => import('../pages/superadmin/dashboard/page'));
const SuperAdminLogs = lazy(() => import('../pages/superadmin/logs/page'));
const SuperAdminConfiguracion = lazy(() => import('../pages/superadmin/configuracion/page'));
const SuperAdminDiplomas = lazy(() => import('../pages/superadmin/diplomas/page'));
const SuperAdminSedesPage = lazy(() => import('../pages/superadmin/sedes/page'));

// Docente pages
const DocenteDashboard = lazy(() => import('../pages/docente/dashboard/page'));
const DocenteCalificaciones = lazy(() => import('../pages/docente/calificaciones/page'));
const DocenteBoletines = lazy(() => import('../pages/docente/boletines/page'));
const DocenteCargaMasivaCalificaciones = lazy(() => import('../pages/docente/carga-masiva-calificaciones/page'));
const DocenteCarteleraPage = lazy(() => import('../pages/docente/cartelera/page'));

// Estudiante pages
const EstudianteCalificaciones = lazy(() => import('../pages/estudiante/calificaciones/page'));

// Componente de carga
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<LoadingFallback />}><HomePage /></Suspense>,
  },
  {
    path: '/login',
    element: <Suspense fallback={<LoadingFallback />}><LoginPage /></Suspense>,
  },
  {
    path: '/forgot-password',
    element: <Suspense fallback={<LoadingFallback />}><ForgotPasswordPage /></Suspense>
  },
  {
    path: '/cambio-contrasena',
    element: <Suspense fallback={<LoadingFallback />}><CambioContrasenaPage /></Suspense>
  },
  {
    path: '/setup-superadmin',
    element: <Suspense fallback={<LoadingFallback />}><SetupSuperAdminPage /></Suspense>
  },
  {
    path: '/recover-access',
    element: <RecoverAccessPage />,
  },
  // Admin routes
  {
    path: '/admin/dashboard',
    element: <Suspense fallback={<LoadingFallback />}><AdminDashboard /></Suspense>,
  },
  {
    path: '/admin/usuarios',
    element: <Suspense fallback={<LoadingFallback />}><AdminUsuarios /></Suspense>,
  },
  {
    path: '/admin/estudiantes',
    element: <Suspense fallback={<LoadingFallback />}><AdminEstudiantes /></Suspense>,
  },
  {
    path: '/admin/materias',
    element: <Suspense fallback={<LoadingFallback />}><AdminMaterias /></Suspense>,
  },
  {
    path: '/admin/grados',
    element: <Suspense fallback={<LoadingFallback />}><AdminGrados /></Suspense>,
  },
  {
    path: '/admin/grupos',
    element: <Suspense fallback={<LoadingFallback />}><AdminGrupos /></Suspense>,
  },
  {
    path: '/admin/periodos',
    element: <Suspense fallback={<LoadingFallback />}><AdminPeriodos /></Suspense>,
  },
  {
    path: '/admin/asignaciones',
    element: <Suspense fallback={<LoadingFallback />}><AdminAsignaciones /></Suspense>,
  },
  {
    path: '/admin/boletines',
    element: <Suspense fallback={<LoadingFallback />}><AdminBoletines /></Suspense>,
  },
  {
    path: '/admin/estudiantes/boletines',
    element: <Suspense fallback={<LoadingFallback />}><AdminBoletines /></Suspense>,
  },
  {
    path: '/admin/carga-masiva',
    element: <Suspense fallback={<LoadingFallback />}><AdminCargaMasiva /></Suspense>,
  },
  {
    path: '/admin/configuracion-calificaciones',
    element: <Suspense fallback={<LoadingFallback />}><AdminConfiguracionCalificaciones /></Suspense>,
  },
  {
    path: '/admin/anos-academicos',
    element: <Suspense fallback={<LoadingFallback />}><AdminAñosAcademicos /></Suspense>,
  },
  {
    path: '/admin/cartelera',
    element: <Suspense fallback={<LoadingFallback />}><AdminCarteleraPage /></Suspense>,
  },
  {
    path: '/admin/informacion-anos-cerrados',
    element: <Suspense fallback={<LoadingFallback />}><AdminInformacionAñosCerrados /></Suspense>,
  },
  {
    path: '/admin/copias-seguridad',
    element: <Suspense fallback={<LoadingFallback />}><AdminCopiasSeguridad /></Suspense>,
  },
  {
    path: '/superadmin/dashboard',
    element: <Suspense fallback={<LoadingFallback />}><SuperAdminDashboard /></Suspense>,
  },
  {
    path: '/superadmin/logs',
    element: <Suspense fallback={<LoadingFallback />}><SuperAdminLogs /></Suspense>,
  },
  {
    path: '/superadmin/diplomas',
    element: <Suspense fallback={<LoadingFallback />}><SuperAdminDiplomas /></Suspense>,
  },
  {
    path: '/superadmin/configuracion',
    element: <Suspense fallback={<LoadingFallback />}><SuperAdminConfiguracion /></Suspense>,
  },
  {
    path: '/superadmin/sedes',
    element: <Suspense fallback={<LoadingFallback />}><SuperAdminSedesPage /></Suspense>,
  },
  // Docente routes
  {
    path: '/docente/dashboard',
    element: <Suspense fallback={<LoadingFallback />}><DocenteDashboard /></Suspense>,
  },
  {
    path: '/docente/calificaciones',
    element: <Suspense fallback={<LoadingFallback />}><DocenteCalificaciones /></Suspense>,
  },
  {
    path: '/docente/boletines',
    element: <Suspense fallback={<LoadingFallback />}><DocenteBoletines /></Suspense>,
  },
  {
    path: '/docente/carga-masiva-calificaciones',
    element: <Suspense fallback={<LoadingFallback />}><DocenteCargaMasivaCalificaciones /></Suspense>,
  },
  {
    path: '/docente/cartelera',
    element: <Suspense fallback={<LoadingFallback />}><DocenteCarteleraPage /></Suspense>,
  },
  // Estudiante routes
  {
    path: '/estudiante/calificaciones',
    element: <Suspense fallback={<LoadingFallback />}><EstudianteCalificaciones /></Suspense>,
  },
  // 404 - debe ir al final
  {
    path: '*',
    element: <Suspense fallback={<LoadingFallback />}><NotFoundPage /></Suspense>,
  }
];

export default routes;
